import { useEffect, useState } from "react";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { FileInput } from "../../../../theme/Component/FileInput";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { MyEditor } from "../../../../theme/Component/MyEditor";
import { useInternalMenuItem } from "./useInternalMenuItem";

interface Props {
    _idMenu: any;
}

export const InternalMenuItem = ({ _idMenu }: Props) => {

    const {
        bean,
        setBean,
        lista,
        modal,
        modalConfirm,
        setModal,
        setModalConfirm,
        single,
        eliminarItem,
        iconButtonsItem,
        head,
        setRowBean,
        updateItem,
    } = useInternalMenuItem({ idMenu: _idMenu });

    const listaBotones = () => {
        const botones = [
            { titulo: "Editar", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModal({ ...modal, view: true, name: `Editar ${bean.Name}` }) } },
            { titulo: "Eliminar", icono: "ri-file-user-line", visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, view: true }) } },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />
                </div>
            </div>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Titulo: </label>
                        <input type="text" className="form-control " value={bean.Title} onChange={(e) => { setBean({ ...bean, 'Title': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={bean.ObjMedia?.Media}
                            MediaContext={bean.ObjMedia?.MediaContext}
                            directory='Multimedia'
                            label='Imagen del menu'
                            docAcept='image/jpeg , image/png'
                            onCreate={({ Media, MediaContext, Name }) => {
                                let x = {
                                    Media: Media,
                                    MediaContext: MediaContext,
                                    Name: Name
                                }
                                setBean({ ...bean, "ImageCover": JSON.stringify(x) })
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Descripción: </label>
                        <MyEditor onChange={(e: any) => { setBean({ ...bean, 'Descripction': e }) }} val={bean.Descripction}></MyEditor>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">URL: </label>
                        <input type="text" className="form-control " value={bean.URL} onChange={(e) => { setBean({ ...bean, 'URL': e.target.value }) }} />
                    </div>
                </div>
            </Modal >
        </>
    );
};
